export default [
  // {
  //   path: '/registration-fee',
  //   name: 'registration-fee',
  //   component: () => import(
  //     /* webpackChunkName: "registration-fee" */ './registration/registration-fee.vue'
  //   ),
  //   meta: {
  //     menuCode: 'pcBuy',
  //     globalCampus: true,
  //   },
  // },
  // {
  //   path: '/student-manage',
  //   name: 'student-manage',
  //   component: () => import(/* webpackChunkName: "student-manage" */ './student/student-manage.vue'),
  //   meta: {
  //     menuCode: 'pcStudentManage',
  //     // globalCampus: 'multiple',
  //   },
  // },
  // {
  //   path: '/student-info/:id',
  //   name: 'student-info',
  //   component: () => import(/* webpackChunkName: "student-info" */ './student/student-info.vue'),
  //   meta: {
  //     noCache: true,
  //   },
  // },
  {
    path: '/receipt',
    name: 'receipt',
    component: () => import(
      /* webpackChunkName: "receipt" */ './registration/receipt/receipt-new.vue'
    ),
    meta: {},
  },
  {
    path: '/receipt-old',
    name: 'receipt-old',
    component: () => import(
      /* webpackChunkName: "receipt-old" */ './registration/receipt/receipt.vue'
    ),
    meta: {},
  },
  {
    path: '/refund',
    name: 'refund',
    component: () => import(/* webpackChunkName: "refund" */ './refund/return.vue'),
    meta: {
      menuCode: 'pcRefund',
      globalCampus: true,
    },
  },
  {
    path: '/carryDown',
    name: 'carryDown',
    component: () => import(/* webpackChunkName: "carryDown" */ './refund/carry-down.vue'),
    meta: {
      globalCampus: true,
    },
  },
  {
    path: '/feeTransfer',
    name: 'feeTransfer',
    component: () => import(
      /* webpackChunkName: "feeTransfer" */ './fee-transfer/fee-transfer.vue'
    ),
    meta: {
      globalCampus: true,
    },
  },
  // {
  //   path: '/student-import',
  //   name: 'student-import',
  //   component:
  // () => import(/* webpackChunkName: "student-import" */ './import/student-import.bak'),
  //   meta: {
  //     globalCampus: true,
  //     menuCode: 'pcImportStudent',
  //   },
  // },
  {
    path: '/import-center',
    name: 'import-center',
    component: () => import(
      /* webpackChunkName: "import-center" */ './import/import-center.vue'
    ),
    meta: {
      menuCode: 'pcImportExportManage',
      menuName: '导入管理',
    },
  },
];
